// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import {AddPathElements} from './add-path-elements.js'
import {AssetCloudPersisted} from './asset-cloud-persisted.js'
import {ClearStyle} from './clear-style.js'
import {CreateBlock} from './create-block.js'
import {CreateComment} from './create-comment.js'
import {CreateConnector} from './create-connector.js'
import {CreateGroup} from './create-group.js'
import {CreateInk} from './create-ink.js'
import {CreatePage} from './create-page.js'
import {CreateRecording} from './create-recording.js'
import {CreateShape} from './create-shape.js'
import {DeleteEntities} from './delete-entities.js'
import {InsertChar} from './insert-char.js'
import {InsertString} from './insert-string.js'
import {ModifyBlock} from './modify-block.js'
import {ModifyComment} from './modify-comment.js'
import {ModifyConnector} from './modify-connector.js'
import {ModifyGroup} from './modify-group.js'
import {ModifyInk} from './modify-ink.js'
import {ModifyPage} from './modify-page.js'
import {ModifyParagraphStyle} from './modify-paragraph-style.js'
import {ModifyPDFField} from './modify-pdffield.js'
import {ModifyPositions} from './modify-positions.js'
import {ModifyRecording} from './modify-recording.js'
import {ModifyShape} from './modify-shape.js'
import {ModifyStyle} from './modify-style.js'
import {PeerInteraction} from './peer-interaction.js'
import {RemoveChar} from './remove-char.js'
import {RemoveChars} from './remove-chars.js'
import {ReviveChars} from './revive-chars.js'
import {SetMetadata} from './set-metadata.js'
import {TransientInteractionEnded} from './transient-interaction-ended.js'
import {UpdateCheckbox} from './update-checkbox.js'

export enum PayloadType {
  NONE = 0,
  SetMetadata = 1,
  AssetCloudPersisted = 2,
  CreatePage = 3,
  ModifyPage = 4,
  CreateRecording = 5,
  ModifyRecording = 6,
  InsertChar = 7,
  InsertString = 8,
  RemoveChar = 9,
  RemoveChars = 10,
  ReviveChars = 11,
  ModifyStyle = 12,
  ModifyParagraphStyle = 13,
  ClearStyle = 14,
  CreateInk = 15,
  AddPathElements = 16,
  ModifyInk = 17,
  CreateShape = 18,
  ModifyShape = 19,
  CreateGroup = 20,
  ModifyGroup = 21,
  CreateBlock = 22,
  ModifyBlock = 23,
  ModifyPositions = 24,
  DeleteEntities = 25,
  TransientInteractionEnded = 26,
  ModifyPDFField = 27,
  UpdateCheckbox = 28,
  PeerInteraction = 29,
  CreateComment = 30,
  ModifyComment = 31,
  CreateConnector = 32,
  ModifyConnector = 33
}

export function unionToPayloadType(
  type: PayloadType,
  accessor: (
    obj:
      | AddPathElements
      | AssetCloudPersisted
      | ClearStyle
      | CreateBlock
      | CreateComment
      | CreateConnector
      | CreateGroup
      | CreateInk
      | CreatePage
      | CreateRecording
      | CreateShape
      | DeleteEntities
      | InsertChar
      | InsertString
      | ModifyBlock
      | ModifyComment
      | ModifyConnector
      | ModifyGroup
      | ModifyInk
      | ModifyPDFField
      | ModifyPage
      | ModifyParagraphStyle
      | ModifyPositions
      | ModifyRecording
      | ModifyShape
      | ModifyStyle
      | PeerInteraction
      | RemoveChar
      | RemoveChars
      | ReviveChars
      | SetMetadata
      | TransientInteractionEnded
      | UpdateCheckbox
  ) =>
    | AddPathElements
    | AssetCloudPersisted
    | ClearStyle
    | CreateBlock
    | CreateComment
    | CreateConnector
    | CreateGroup
    | CreateInk
    | CreatePage
    | CreateRecording
    | CreateShape
    | DeleteEntities
    | InsertChar
    | InsertString
    | ModifyBlock
    | ModifyComment
    | ModifyConnector
    | ModifyGroup
    | ModifyInk
    | ModifyPDFField
    | ModifyPage
    | ModifyParagraphStyle
    | ModifyPositions
    | ModifyRecording
    | ModifyShape
    | ModifyStyle
    | PeerInteraction
    | RemoveChar
    | RemoveChars
    | ReviveChars
    | SetMetadata
    | TransientInteractionEnded
    | UpdateCheckbox
    | null
):
  | AddPathElements
  | AssetCloudPersisted
  | ClearStyle
  | CreateBlock
  | CreateComment
  | CreateConnector
  | CreateGroup
  | CreateInk
  | CreatePage
  | CreateRecording
  | CreateShape
  | DeleteEntities
  | InsertChar
  | InsertString
  | ModifyBlock
  | ModifyComment
  | ModifyConnector
  | ModifyGroup
  | ModifyInk
  | ModifyPDFField
  | ModifyPage
  | ModifyParagraphStyle
  | ModifyPositions
  | ModifyRecording
  | ModifyShape
  | ModifyStyle
  | PeerInteraction
  | RemoveChar
  | RemoveChars
  | ReviveChars
  | SetMetadata
  | TransientInteractionEnded
  | UpdateCheckbox
  | null {
  switch (PayloadType[type]) {
    case 'NONE':
      return null
    case 'SetMetadata':
      return accessor(new SetMetadata())! as SetMetadata
    case 'AssetCloudPersisted':
      return accessor(new AssetCloudPersisted())! as AssetCloudPersisted
    case 'CreatePage':
      return accessor(new CreatePage())! as CreatePage
    case 'ModifyPage':
      return accessor(new ModifyPage())! as ModifyPage
    case 'CreateRecording':
      return accessor(new CreateRecording())! as CreateRecording
    case 'ModifyRecording':
      return accessor(new ModifyRecording())! as ModifyRecording
    case 'InsertChar':
      return accessor(new InsertChar())! as InsertChar
    case 'InsertString':
      return accessor(new InsertString())! as InsertString
    case 'RemoveChar':
      return accessor(new RemoveChar())! as RemoveChar
    case 'RemoveChars':
      return accessor(new RemoveChars())! as RemoveChars
    case 'ReviveChars':
      return accessor(new ReviveChars())! as ReviveChars
    case 'ModifyStyle':
      return accessor(new ModifyStyle())! as ModifyStyle
    case 'ModifyParagraphStyle':
      return accessor(new ModifyParagraphStyle())! as ModifyParagraphStyle
    case 'ClearStyle':
      return accessor(new ClearStyle())! as ClearStyle
    case 'CreateInk':
      return accessor(new CreateInk())! as CreateInk
    case 'AddPathElements':
      return accessor(new AddPathElements())! as AddPathElements
    case 'ModifyInk':
      return accessor(new ModifyInk())! as ModifyInk
    case 'CreateShape':
      return accessor(new CreateShape())! as CreateShape
    case 'ModifyShape':
      return accessor(new ModifyShape())! as ModifyShape
    case 'CreateGroup':
      return accessor(new CreateGroup())! as CreateGroup
    case 'ModifyGroup':
      return accessor(new ModifyGroup())! as ModifyGroup
    case 'CreateBlock':
      return accessor(new CreateBlock())! as CreateBlock
    case 'ModifyBlock':
      return accessor(new ModifyBlock())! as ModifyBlock
    case 'ModifyPositions':
      return accessor(new ModifyPositions())! as ModifyPositions
    case 'DeleteEntities':
      return accessor(new DeleteEntities())! as DeleteEntities
    case 'TransientInteractionEnded':
      return accessor(new TransientInteractionEnded())! as TransientInteractionEnded
    case 'ModifyPDFField':
      return accessor(new ModifyPDFField())! as ModifyPDFField
    case 'UpdateCheckbox':
      return accessor(new UpdateCheckbox())! as UpdateCheckbox
    case 'PeerInteraction':
      return accessor(new PeerInteraction())! as PeerInteraction
    case 'CreateComment':
      return accessor(new CreateComment())! as CreateComment
    case 'ModifyComment':
      return accessor(new ModifyComment())! as ModifyComment
    case 'CreateConnector':
      return accessor(new CreateConnector())! as CreateConnector
    case 'ModifyConnector':
      return accessor(new ModifyConnector())! as ModifyConnector
    default:
      return null
  }
}

export function unionListToPayloadType(
  type: PayloadType,
  accessor: (
    index: number,
    obj:
      | AddPathElements
      | AssetCloudPersisted
      | ClearStyle
      | CreateBlock
      | CreateComment
      | CreateConnector
      | CreateGroup
      | CreateInk
      | CreatePage
      | CreateRecording
      | CreateShape
      | DeleteEntities
      | InsertChar
      | InsertString
      | ModifyBlock
      | ModifyComment
      | ModifyConnector
      | ModifyGroup
      | ModifyInk
      | ModifyPDFField
      | ModifyPage
      | ModifyParagraphStyle
      | ModifyPositions
      | ModifyRecording
      | ModifyShape
      | ModifyStyle
      | PeerInteraction
      | RemoveChar
      | RemoveChars
      | ReviveChars
      | SetMetadata
      | TransientInteractionEnded
      | UpdateCheckbox
  ) =>
    | AddPathElements
    | AssetCloudPersisted
    | ClearStyle
    | CreateBlock
    | CreateComment
    | CreateConnector
    | CreateGroup
    | CreateInk
    | CreatePage
    | CreateRecording
    | CreateShape
    | DeleteEntities
    | InsertChar
    | InsertString
    | ModifyBlock
    | ModifyComment
    | ModifyConnector
    | ModifyGroup
    | ModifyInk
    | ModifyPDFField
    | ModifyPage
    | ModifyParagraphStyle
    | ModifyPositions
    | ModifyRecording
    | ModifyShape
    | ModifyStyle
    | PeerInteraction
    | RemoveChar
    | RemoveChars
    | ReviveChars
    | SetMetadata
    | TransientInteractionEnded
    | UpdateCheckbox
    | null,
  index: number
):
  | AddPathElements
  | AssetCloudPersisted
  | ClearStyle
  | CreateBlock
  | CreateComment
  | CreateConnector
  | CreateGroup
  | CreateInk
  | CreatePage
  | CreateRecording
  | CreateShape
  | DeleteEntities
  | InsertChar
  | InsertString
  | ModifyBlock
  | ModifyComment
  | ModifyConnector
  | ModifyGroup
  | ModifyInk
  | ModifyPDFField
  | ModifyPage
  | ModifyParagraphStyle
  | ModifyPositions
  | ModifyRecording
  | ModifyShape
  | ModifyStyle
  | PeerInteraction
  | RemoveChar
  | RemoveChars
  | ReviveChars
  | SetMetadata
  | TransientInteractionEnded
  | UpdateCheckbox
  | null {
  switch (PayloadType[type]) {
    case 'NONE':
      return null
    case 'SetMetadata':
      return accessor(index, new SetMetadata())! as SetMetadata
    case 'AssetCloudPersisted':
      return accessor(index, new AssetCloudPersisted())! as AssetCloudPersisted
    case 'CreatePage':
      return accessor(index, new CreatePage())! as CreatePage
    case 'ModifyPage':
      return accessor(index, new ModifyPage())! as ModifyPage
    case 'CreateRecording':
      return accessor(index, new CreateRecording())! as CreateRecording
    case 'ModifyRecording':
      return accessor(index, new ModifyRecording())! as ModifyRecording
    case 'InsertChar':
      return accessor(index, new InsertChar())! as InsertChar
    case 'InsertString':
      return accessor(index, new InsertString())! as InsertString
    case 'RemoveChar':
      return accessor(index, new RemoveChar())! as RemoveChar
    case 'RemoveChars':
      return accessor(index, new RemoveChars())! as RemoveChars
    case 'ReviveChars':
      return accessor(index, new ReviveChars())! as ReviveChars
    case 'ModifyStyle':
      return accessor(index, new ModifyStyle())! as ModifyStyle
    case 'ModifyParagraphStyle':
      return accessor(index, new ModifyParagraphStyle())! as ModifyParagraphStyle
    case 'ClearStyle':
      return accessor(index, new ClearStyle())! as ClearStyle
    case 'CreateInk':
      return accessor(index, new CreateInk())! as CreateInk
    case 'AddPathElements':
      return accessor(index, new AddPathElements())! as AddPathElements
    case 'ModifyInk':
      return accessor(index, new ModifyInk())! as ModifyInk
    case 'CreateShape':
      return accessor(index, new CreateShape())! as CreateShape
    case 'ModifyShape':
      return accessor(index, new ModifyShape())! as ModifyShape
    case 'CreateGroup':
      return accessor(index, new CreateGroup())! as CreateGroup
    case 'ModifyGroup':
      return accessor(index, new ModifyGroup())! as ModifyGroup
    case 'CreateBlock':
      return accessor(index, new CreateBlock())! as CreateBlock
    case 'ModifyBlock':
      return accessor(index, new ModifyBlock())! as ModifyBlock
    case 'ModifyPositions':
      return accessor(index, new ModifyPositions())! as ModifyPositions
    case 'DeleteEntities':
      return accessor(index, new DeleteEntities())! as DeleteEntities
    case 'TransientInteractionEnded':
      return accessor(index, new TransientInteractionEnded())! as TransientInteractionEnded
    case 'ModifyPDFField':
      return accessor(index, new ModifyPDFField())! as ModifyPDFField
    case 'UpdateCheckbox':
      return accessor(index, new UpdateCheckbox())! as UpdateCheckbox
    case 'PeerInteraction':
      return accessor(index, new PeerInteraction())! as PeerInteraction
    case 'CreateComment':
      return accessor(index, new CreateComment())! as CreateComment
    case 'ModifyComment':
      return accessor(index, new ModifyComment())! as ModifyComment
    case 'CreateConnector':
      return accessor(index, new CreateConnector())! as CreateConnector
    case 'ModifyConnector':
      return accessor(index, new ModifyConnector())! as ModifyConnector
    default:
      return null
  }
}
